import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { api } from '../App';
import { BookOpen, Clock, Shield, CheckCircle } from 'lucide-react';

export default function AssessmentIntro({ user }) {
  const navigate = useNavigate();

  const startAssessment = async () => {
    try {
      const response = await api.post('/assessments', {
        assessment_type: 'student_self'
      });
      navigate(`/assessment/${response.data.id}`);
    } catch (error) {
      console.error('Failed to start assessment:', error);
      toast.error('Envanter başlatılamadı');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-emerald-50 flex items-center justify-center p-6">
      <div className="w-full max-w-3xl animate-fade-in">
        <Card className="shadow-xl border-none" data-testid="assessment-intro-card">
          <CardHeader className="text-center pb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-emerald-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <BookOpen className="w-8 h-8 text-white" />
            </div>
            <CardTitle className="text-3xl font-bold text-slate-800">Mizaç Envanterine Hoş Geldin!</CardTitle>
            <CardDescription className="text-base mt-2">
              Kendini daha iyi tanıman için hazırlanmış soruları cevaplayacaksın
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            {/* Info Cards */}
            <div className="grid md:grid-cols-3 gap-4">
              <div className="flex flex-col items-center text-center p-4 bg-blue-50 rounded-xl" data-testid="info-duration">
                <Clock className="w-8 h-8 text-blue-600 mb-2" />
                <p className="font-semibold text-slate-800">10-15 Dakika</p>
                <p className="text-sm text-slate-600">Süre</p>
              </div>
              <div className="flex flex-col items-center text-center p-4 bg-emerald-50 rounded-xl" data-testid="info-questions">
                <CheckCircle className="w-8 h-8 text-emerald-600 mb-2" />
                <p className="font-semibold text-slate-800">20 Soru</p>
                <p className="text-sm text-slate-600">Kısa ve Anlaşılır</p>
              </div>
              <div className="flex flex-col items-center text-center p-4 bg-teal-50 rounded-xl" data-testid="info-privacy">
                <Shield className="w-8 h-8 text-teal-600 mb-2" />
                <p className="font-semibold text-slate-800">Güvenli</p>
                <p className="text-sm text-slate-600">Bilimsel Altyapı</p>
              </div>
            </div>

            {/* Important Notes */}
            <div className="bg-slate-50 p-6 rounded-xl space-y-3">
              <h3 className="font-semibold text-slate-800 mb-3">Önemli Notlar:</h3>
              <ul className="space-y-2 text-slate-700">
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                  <span>Doğru veya yanlış cevap yok. Her soru senin hakkında bilgi topluyor.</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                  <span>İçten ve dürüst yanıtlar vermek, raporunun daha doğru olmasını sağlar.</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                  <span>Çok düşünmeden, ilk gelen his ve düşüncenle cevap ver.</span>
                </li>
                <li className="flex items-start gap-2">
                  <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                  <span>Envanter bitince kişiselleştirilmiş rapor hemen hazır olacak.</span>
                </li>
              </ul>
            </div>

            {/* Action Buttons */}
            <div className="flex gap-3 pt-4">
              <Button
                variant="outline"
                className="flex-1"
                onClick={() => navigate('/')}
                data-testid="back-btn"
              >
                Geri Dön
              </Button>
              <Button
                className="flex-1 bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-700 hover:to-emerald-700 text-lg py-6"
                onClick={startAssessment}
                data-testid="start-assessment-btn"
              >
                Başlayalım!
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}